import React from 'react';
import { useEffect, useState, useContext } from 'react';
import Header from '../dashboard/Header/Header'
import TextField from '@mui/material/TextField'
import CssBaseline from '@mui/material/CssBaseline';
 
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import { Button } from '@mui/material';
 
import { Link, useNavigate } from 'react-router-dom';
 
import './auth.css';
import AuthContext from './Auth-context';
import { sendPasswordResetEmail } from 'firebase/auth';
import {auth, provider} from './config';
 




const ForgotPassword = () => {
    const history = useNavigate();
    const [screenheight, setscreenheight] = useState();
    const authCtx = useContext(AuthContext);
    const [emailApproved, setEmailApproved] = useState(false);
    
useEffect(() => {
      setscreenheight(window.innerHeight - 150 +'px')
       console.log(window.innerHeight);
    }, [])

const passwordResetHandler = (status) => {
    let userName = document.getElementById('filled-basic').value;
    if(status === true){
        sendPasswordResetEmail(auth, userName).then(data => {
            setEmailApproved(true);
            setTimeout(() => {
                history("/auth/login");
            }, 6000);
        }).catch(err=>{
            setEmailApproved(false);
            alert(err.message);
        }) 
    }
    
   
}
   
    return (
      <div>
        <Header/>
        <CssBaseline />
        {screenheight ?   <div className='signupcontainer' style={{height: screenheight}}>
        <Container maxWidth="md">
        <Grid container spacing={2}>
        <Grid xs={12} md={6}>
        <h2>Forgot your password?</h2>
        <p><small>To reset your password, please enter the email address of your taskticks account.</small></p>
        <div className='InputField'>
        <TextField className='fieldCS'  id="filled-basic" label="Email" variant="filled" />
        </div>
        
      <Button variant="contained" onClick={()=> passwordResetHandler(true)}  style={{textTransform: "inherit", width: '100%', background: '#770A97'}}>Reset my password</Button>  
       {emailApproved && <h4>Please check your <a href='https://mail.google.com/mail/u/0/#inbox' target='_blank'>gmail to reset your password</a></h4>} 
        </Grid>
        <Grid xs={12} md={6}>
        <img className='imageWidth' src='https://todoist.b-cdn.net/assets/images/9ba6f31fc750cc2b5eaf8b4fbeec2788.png' />
        </Grid>
        </Grid>
        </Container>
        </div> : ''}
        
        
      </div>
    )
  }
 

export default ForgotPassword
